import moment from "moment"
import { MENU_MESA_ENTRADA } from "../utils/constants"

export const armarParametros =
  (idEspecialidad, idCentroMedico = null, idProfesional = null, presencial = null, virtual = null, fecha = null
    , hora = null, idTipoParametrizacion = null, filtrarPorUsuario = true, demanda = null, sobreTurnos = null
    , filtros = null, fechaHasta = null, edadAfiliado = null, fechaDesde = null, callCenter = false) => {
    let str = ''
    if (idEspecialidad !== null)
      str += `&idEspecialidad=${idEspecialidad}`
    if (idCentroMedico !== null)
      str += `&idCentroMedico=${idCentroMedico}`
    if (idProfesional !== null)
      str += `&idProfesional=${idProfesional}`
    if (presencial !== null)
      str += `&presencial=${presencial}`
    if (virtual !== null)
      str += `&videoConsulta=${virtual}`
    if (fecha !== null)
      str += `&fecha=${fecha}`
    if (hora !== null)
      str += `&hora=${hora}`
    if (idTipoParametrizacion !== null)
      str += `&idTipoParametrizacion=${idTipoParametrizacion}`
    if (filtrarPorUsuario)
      str += `&filtrarPorUsuario=${filtrarPorUsuario}`
    if (demanda)
      str += `&demanda=${demanda}`
    if (sobreTurnos)
      str += `&sobreTurnos=${sobreTurnos}`
    if (filtros)
      str += `&filtros=${filtros}`
    if (fechaHasta)
      str += `&fechaHasta=${fechaHasta}`
    if (edadAfiliado || edadAfiliado === 0)
      str += `&edadAfiliado=${edadAfiliado}`
    if (fechaDesde)
      str += `&fechaDesde=${fechaDesde}`
    if (callCenter)
      str += `&callCenter=${callCenter}`
    return str;
  }

export const armarParametrosAutorizaciones = (idAfiliado, idEfectorFacturacion, idBandeja, fechaDesde, fechaHasta,
  idEstadoSolicitud, idEstadoPresupuesto, idPrestador, idCartillaPrestador, idEfectorFacturacionPrestador, rolIngresoInterDom,
  idSolicitud, rolIngresoAutorizaciones, idTipoSolicitud, idSeccional, page, pageSize, rolIngresoOxigeno) => {
  let p1 = idAfiliado ? `&idAfiliado=${idAfiliado}` : ``;
  let p2 = idEfectorFacturacion ? `&idEfectorFacturacion=${idEfectorFacturacion}` : ``;
  let p3 = idBandeja ? `&idBandeja=${idBandeja}` : ``;
  let p4 = fechaDesde ? `&fechaDesde=${fechaDesde.toISOString()}` : ``;
  let p5 = fechaHasta ? `&fechaHasta=${fechaHasta.toISOString()}` : ``;
  let p6 = idEstadoSolicitud ? `&idEstadoSolicitud=${idEstadoSolicitud}` : ``;
  let p7 = idEstadoPresupuesto ? `&idEstadoPresupuesto=${idEstadoPresupuesto}` : ``;
  let p8 = idPrestador ? `&idPrestador=${idPrestador}` : ``;
  let p9 = idCartillaPrestador ? `&idCartillaPrestador=${idCartillaPrestador}` : ``;
  let p10 = idEfectorFacturacionPrestador ? `&idEfectorFacturacionPrestador=${idEfectorFacturacionPrestador}` : ``;
  let p11 = rolIngresoInterDom ? `&rolIngresoInternacionDomiciliaria=${rolIngresoInterDom}` : ``;
  let p12 = idSolicitud ? `&idSolicitud=${idSolicitud}` : ``;
  let p13 = rolIngresoAutorizaciones ? `&rolIngresoAutorizaciones=${rolIngresoAutorizaciones}` : ``;
  let p14 = idTipoSolicitud ? `&idTipoSolicitud=${idTipoSolicitud}` : ``
  let p15 = idSeccional ? `&idSeccional=${idSeccional}` : ``
  let p16 = page ? `&page=${page}` : ``
  let p17 = pageSize ? `&pageSize=${pageSize}` : ``
  let p18 = rolIngresoOxigeno ? `&rolIngresoOxigeno=${rolIngresoOxigeno}` : ``;

  return `${p1}${p2}${p3}${p4}${p5}${p6}${p7}${p8}${p9}${p10}${p11}${p12}${p13}${p14}${p15}${p16}${p17}${p18}`;
}

export const armarParametrosDisca = (idAfiliado, fechaDesde, fechaHasta, idSolicitud, idEstadoSolicitud, idCodNom) => {
  let p1 = idAfiliado ? `&idAfiliado=${idAfiliado}` : ``;
  let p2 = fechaDesde ? `&fechaDesde=${fechaDesde.toISOString()}` : ``;
  let p3 = fechaHasta ? `&fechaHasta=${fechaHasta.toISOString()}` : ``;
  let p4 = idSolicitud ? `&idSolicitud=${idSolicitud}` : ``;
  let p5 = idEstadoSolicitud ? `&idEstadoSolicitud=${idEstadoSolicitud}` : ``;
  // let p6 = idCodNom ? `&idCodNom=${idCodNom}` : ``;


  return `${p1}${p2}${p3}${p4}${p5}`;
}
export const armarParametrosBuscadorAutorizaciones = (idAfiliado, fechaDesde, fechaHasta, idSolicitud) => {
  let p1 = idAfiliado ? `&idAfiliado=${idAfiliado}` : ``;
  let p2 = fechaDesde ? `&fechaDesde=${fechaDesde.toISOString()}` : ``;
  let p3 = fechaHasta ? `&fechaHasta=${fechaHasta.toISOString()}` : ``;
  let p4 = idSolicitud ? `&idSolicitud=${idSolicitud}` : ``;


  return `${p1}${p2}${p3}${p4}`;
}

export const armarParametrosDatosModificacionInternacion = (idAfiliado, idSolicitud) => {
  let p1 = idAfiliado ? `&idAfiliado=${idAfiliado}` : ``;
  let p2 = idSolicitud ? `&idSolicitud=${idSolicitud}` : ``;


  return `${p1}${p2}`;
}

export const armarParametrosBuscadorPresupuestos = (idAfiliado, idPresupuesto, fechaDesde, fechaHasta) => {
  let p1 = idAfiliado ? `&idAfiliado=${idAfiliado}` : ``;
  let p2 = idPresupuesto ? `&idPresupuesto=${idPresupuesto}` : ``;
  let p3 = fechaDesde ? `&fechaDesde=${fechaDesde.toISOString()}` : ``;
  let p4 = fechaHasta ? `&fechaHasta=${fechaHasta.toISOString()}` : ``;

  return `${p1}${p2}${p3}${p4}`;
}

export const armarParametrosRecetas = (idAfiliado, idMedicamento, fechaDesde, fechaHasta,
  idEstadoReceta, idObraSocial) => {
  let p1 = idAfiliado ? `&idAfiliado=${idAfiliado}` : ``;
  let p2 = idMedicamento ? `&idMedicamento=${idMedicamento}` : ``;
  let p3 = fechaDesde ? `&fechaDesde=${fechaDesde.toISOString()}` : ``;
  let p4 = fechaHasta ? `&fechaHasta=${fechaHasta.toISOString()}` : ``;
  let p5 = idEstadoReceta ? `&idEstadoReceta=${idEstadoReceta}` : ``;
  let p6 = idObraSocial ? `&idObraSocial=${idObraSocial}` : ``;

  return `${p1}${p2}${p3}${p4}${p5}${p6}`;
}

export const armarParametrosEmpadronamiento = (idAfiliado, idTipoEmpadronamiento, fechaDesde, fechaHasta, fechaCargaDesde,
  fechaCargaHasta, idPatologia, idSolicitudEmp, nroPedido, idSolicitud, idEstadoSolicitud, esAuditor, esAuditorEsp,
  esAuditorDisca, esConsulta, esSoloInicio) => {
  let p1 = idAfiliado ? `&idAfiliado=${idAfiliado}` : ``;
  let p2 = idTipoEmpadronamiento ? `&idTipoEmpadronamiento=${idTipoEmpadronamiento}` : ``;
  let p3 = fechaDesde ? `&fechaDesde=${fechaDesde.toISOString()}` : ``;
  let p4 = fechaHasta ? `&fechaHasta=${fechaHasta.toISOString()}` : ``;
  let p5 = fechaCargaDesde ? `&fechaCargaDesde=${fechaCargaDesde.toISOString()}` : ``;
  let p6 = fechaCargaHasta ? `&fechaCargaHasta=${fechaCargaHasta.toISOString()}` : ``;
  let p7 = idPatologia ? `&idPatologia=${idPatologia}` : ``;
  let p8 = idSolicitudEmp ? `&idSolicitudEmp=${idSolicitudEmp}` : ``;
  let p9 = nroPedido ? `&nroPedidoSC=${nroPedido}` : ``;
  let p10 = idSolicitud ? `&idSolicitud=${idSolicitud}` : ``;
  let p11 = idEstadoSolicitud ? `&idEstadoSolicitud=${idEstadoSolicitud}` : ``;
  let p12 = esAuditor ? `&esAuditor=${esAuditor}` : ``;
  let p13 = esAuditorEsp ? `&esAuditorEsp=${esAuditorEsp}` : ``;
  let p14 = esAuditorDisca ? `&esAuditorDisca=${esAuditorDisca}` : ``;
  let p15 = esConsulta ? `&esConsulta=${esConsulta}` : ``;
  let p16 = esSoloInicio ? `&esSoloInicio=${esSoloInicio}` : ``;

  return `${p1}${p2}${p3}${p4}${p5}${p6}${p7}${p8}${p9}${p10}${p11}${p12}${p13}${p14}${p15}${p16}`;
}

export const armarParametrosLiquidaciones = (idEfectorFacturacion, fechaDesde, fechaHasta,
  idEstado, idComprobante) => {
  let p1 = idEfectorFacturacion ? `&idEfectorFacturacion=${idEfectorFacturacion}` : ``;
  let p2 = fechaDesde ? `&fechaDesde=${fechaDesde.toISOString()}` : ``;
  let p3 = fechaHasta ? `&fechaHasta=${fechaHasta.toISOString()}` : ``;
  let p4 = idEstado ? `&idEstado=${idEstado}` : ``;
  let p5 = idComprobante ? `&idComprobante=${idComprobante}` : ``;
  return `${p1}${p2}${p3}${p4}${p5}`;
}

export const armarParametrosBuscadorMesa = (idTipoEfector, activeBreadcrumb, tipoComprobanteDocumento, buscador) => {
  if (activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES) {
    let p1 = idTipoEfector ? `&idTipoEfector=${idTipoEfector}` : ``;
    let p2 = buscador ? `&buscador=${buscador.toString()}` : ``;
    return `${p1}${p2}`;
  } else {
    let p1 = tipoComprobanteDocumento ? `&tipoComprobanteDocumento=${tipoComprobanteDocumento}` : ``;
    let p2 = buscador ? `&buscador=${buscador.toString()}` : ``;
    return `${p1}${p2}`;
  }
}

export const armarParametrosMesaEntrada = (proveedor, idTipoEfector, fechaDesde, fechaHasta, activeBreadcrumb, tipoComprobanteDocumento, idEfectorFacturacion) => {
  if (activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES) {
    let p1 = idTipoEfector ? `&idTipoEfector=${idTipoEfector}` : ``;
    let p2 = fechaDesde ? `&fechaDesde=${moment(fechaDesde).toISOString()}` : ``;
    let p3 = fechaHasta ? `&fechaHasta=${moment(fechaHasta).toISOString()}` : ``;
    let p4 = proveedor ? `&proveedor=${proveedor}` : ``;
    let p5 = idEfectorFacturacion ? `&idEfectorFacturacion=${idEfectorFacturacion}` : ``;
    return `${p1}${p2}${p3}${p4}${p5}`;
  } else {
    let p1 = fechaDesde ? `&fechaDesde=${moment(fechaDesde).toISOString()}` : ``;
    let p2 = fechaHasta ? `&fechaHasta=${moment(fechaHasta).toISOString()}` : ``;
    let p3 = tipoComprobanteDocumento ? `&tipoComprobanteDocumento=${tipoComprobanteDocumento}` : ``;
    return `${p1}${p2}${p3}`;
  }
}

export const armarParametrosMesaEntradaAreas = ({ proveedor, idTipoEfector, fechaDesde, fechaHasta, tipoComprobanteDocumento }, activeBreadcrumb) => {
  if (activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES) {
    let p1 = idTipoEfector ? `&idTipoEfector=${idTipoEfector}` : ``;
    let p2 = fechaDesde ? `&fechaDesde=${moment(fechaDesde).toISOString()}` : ``;
    let p3 = fechaHasta ? `&fechaHasta=${moment(fechaHasta).toISOString()}` : ``;
    let p4 = proveedor ? `&proveedor=${proveedor}` : ``;
    return `${p1}${p2}${p3}${p4}`;
  } else {
    let p1 = fechaDesde ? `&fechaDesde=${moment(fechaDesde).toISOString()}` : ``;
    let p2 = fechaHasta ? `&fechaHasta=${moment(fechaHasta).toISOString()}` : ``;
    let p3 = tipoComprobanteDocumento ? `&tipoComprobanteDocumento=${tipoComprobanteDocumento}` : ``;
    return `${p1}${p2}${p3}`;
  }
}

export const armarParametrosCotizaciones = (idEstado, idAfiliado, idSolicitud, fechaInicio, fechaFin, idTipoSolicitud = null) => {
  let p1 = idEstado ? `&idEstado=${idEstado}` : ``;
  let p2 = idAfiliado ? `&idAfiliado=${idAfiliado}` : ``;
  let p3 = idSolicitud ? `&idSolicitud=${idSolicitud}` : ``;
  let p4 = fechaInicio ? `&fechaInicio=${fechaInicio.toISOString()}` : ``;
  let p5 = fechaFin ? `&fechaFin=${fechaFin.toISOString()}` : ``;
  let p6 = idTipoSolicitud ? `&idTipoSolicitud=${idTipoSolicitud}` : ``;

  return `${p1}${p2}${p3}${p4}${p5}${p6}`;
}

export const armarParametrosAuditoriaFacturas = (idAfiliado, idSolicitudAuditoria, fechaInicio, fechaFin) => {
  let p1 = idAfiliado ? `&idAfiliado=${idAfiliado}` : ``;
  let p2 = idSolicitudAuditoria ? `&idSolicitudAuditoria=${idSolicitudAuditoria}` : ``;
  let p3 = fechaInicio ? `&fechaInicio=${fechaInicio.toISOString()}` : ``;
  let p4 = fechaFin ? `&fechaFin=${fechaFin.toISOString()}` : ``;

  return `${p1}${p2}${p3}${p4}`;
}

export const armarParametrosComunicacionEmpresas = (idEstado, cuit, idAreaUsuario, fechaCargaDesde, fechaCargaHasta, fechaUltimaModificacionDesde, fechaUltimaModificacionHasta) => {
  let p1 = idEstado ? `&idEstado=${idEstado}` : ``;
  let p2 = cuit ? `&cuit=${cuit}` : ``;
  let p3 = idAreaUsuario ? `&idAreaUsuario=${idAreaUsuario}` : ``;
  let p4 = fechaCargaDesde ? `&fechaCargaDesde=${fechaCargaDesde.toISOString()}` : ``;
  let p5 = fechaCargaHasta ? `&fechaCargaHasta=${fechaCargaHasta.toISOString()}` : ``;
  let p6 = fechaUltimaModificacionDesde ? `&fechaUltimaModificacionDesde=${fechaUltimaModificacionDesde.toISOString()}` : ``;
  let p7 = fechaUltimaModificacionHasta ? `&fechaUltimaModificacionHasta=${fechaUltimaModificacionHasta.toISOString()}` : ``;


  return `${p1}${p2}${p3}${p4}${p5}${p6}${p7}`;
}

export const armarParametrosMesaEntradaExcel = (proveedor, idTipoEfector, fechaDesde, fechaHasta, activeBreadcrumb, tipoComprobanteDocumento, idSubArea, idEfectorFacturacion) => {
  if (activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES) {
    let p1 = idTipoEfector ? `&idTipoEfector=${idTipoEfector}` : ``;
    let p2 = fechaDesde ? `&fechaDesde=${moment(fechaDesde).toISOString()}` : ``;
    let p3 = fechaHasta ? `&fechaHasta=${moment(fechaHasta).toISOString()}` : ``;
    let p4 = proveedor ? `&proveedor=${proveedor}` : ``;
    let p5 = idSubArea ? `&idSubArea=${idSubArea}` : ``;
    return `${p1}${p2}${p3}${p4}${p5}`;
  } else {
    let p1 = fechaDesde ? `&fechaDesde=${moment(fechaDesde).toISOString()}` : ``;
    let p2 = fechaHasta ? `&fechaHasta=${moment(fechaHasta).toISOString()}` : ``;
    let p3 = tipoComprobanteDocumento ? `&tipoComprobanteDocumento=${tipoComprobanteDocumento}` : ``;
    let p4 = idSubArea ? `&idSubArea=${idSubArea}` : ``;
    return `${p1}${p2}${p3}${p4}`;
  }
}

export const armarParametrosGetComprobantesRemito = (fechaDesde, fechaHasta,
  idTipoIngreso, generado, idArea, idSubArea) => {
  let p1 = fechaDesde ? `&fechaDesde=${fechaDesde.toISOString()}` : ``;
  let p2 = fechaHasta ? `&fechaHasta=${fechaHasta.toISOString()}` : ``;
  let p3 = idTipoIngreso ? `&idTipoIngreso=${idTipoIngreso}` : ``;
  let p4 = generado ? `&generado=${generado}` : ``;
  let p5 = idArea ? `&idArea=${idArea}` : ``;
  let p6 = idSubArea ? `&idSubArea=${idSubArea}` : ``;
  return `${p1}${p2}${p3}${p4}${p5}${p6}`;
}

export const armarParametrosGetComprobantesDocumentoRemito = (fechaDesde, fechaHasta,
  idTipoIngreso, generado, idArea, idSubArea) => {
  let p1 = fechaDesde ? `&fechaDesde=${fechaDesde.toISOString()}` : ``;
  let p2 = fechaHasta ? `&fechaHasta=${fechaHasta.toISOString()}` : ``;
  let p3 = idTipoIngreso ? `&idTipoIngreso=${idTipoIngreso}` : ``;
  let p4 = generado ? `&generado=${generado}` : ``;
  let p5 = idArea ? `&idArea=${idArea}` : ``;
  let p6 = idSubArea ? `&idSubArea=${idSubArea}` : ``;
  return `${p1}${p2}${p3}${p4}${p5}${p6}`;
}

export const armarParametrosPresupuestos = (idAfiliado, idPresupuesto, fechaDesde, fechaHasta, idEstadoPresupuesto,
  rolIngresoAutorizaciones, idSeccional, idBandeja, idPrestador, idCartillaPrestador, idEfectorFacturacion) => {

  let p1 = idAfiliado ? `&idAfiliado=${idAfiliado}` : ``;
  let p2 = idPresupuesto ? `&idPresupuesto=${idPresupuesto}` : ``;
  let p3 = fechaDesde ? `&fechaDesde=${fechaDesde.toISOString()}` : ``;
  let p4 = fechaHasta ? `&fechaHasta=${fechaHasta.toISOString()}` : ``;
  let p5 = idEstadoPresupuesto ? `&idEstadoPresupuesto=${idEstadoPresupuesto}` : ``;
  let p6 = rolIngresoAutorizaciones ? `&rolIngresoAutorizaciones=${rolIngresoAutorizaciones}` : ``;
  let p7 = idSeccional ? `&idSeccional=${idSeccional}` : ``;
  let p8 = idBandeja ? `&idBandejaAutorizacion=${idBandeja}` : ``;
  let p9 = idPrestador ? `&idPrestador=${idPrestador}` : ``;
  let p10 = idCartillaPrestador ? `&idCartillaPrestador=${idCartillaPrestador}` : ``;
  let p11 = idEfectorFacturacion ? `&idEfectorFacturacion=${idEfectorFacturacion}` : ``;

  return `${p1}${p2}${p3}${p4}${p5}${p6}${p7}${p8}${p9}${p10}${p11}`;
}



export const armarParametrosAdicciones = (idAfiliado, fechaDesde, fechaHasta, idSolicitud, idEstadoSolicitud, idCodNom) => {
  let p1 = idAfiliado ? `&idAfiliado=${idAfiliado}` : ``;
  let p2 = fechaDesde ? `&fechaDesde=${fechaDesde.toISOString()}` : ``;
  let p3 = fechaHasta ? `&fechaHasta=${fechaHasta.toISOString()}` : ``;
  let p4 = idSolicitud ? `&idSolicitud=${idSolicitud}` : ``;
  let p5 = idEstadoSolicitud ? `&idEstadoSolicitud=${idEstadoSolicitud}` : ``;
  // let p6 = idCodNom ? `&idCodNom=${idCodNom}` : ``;


  return `${p1}${p2}${p3}${p4}${p5}`;
}

export const armarParametrosMesaEntradaBuscador = (tipoConsulta, idEfectorFacturacion, idExpediente, idExpedienteSV, nroSucursal, nroFactura) => {

  let p1 = tipoConsulta ? `&tipoConsulta=${tipoConsulta}` : ``;
  let p2 = idEfectorFacturacion ? `&idEfectorFacturacion=${idEfectorFacturacion}` : ``;
  let p3 = idExpediente ? `&idExpediente=${idExpediente}` : ``;
  let p4 = idExpedienteSV ? `&idExpedienteSV=${idExpedienteSV}` : ``;
  let p5 = nroSucursal ? `&nroSucursal=${nroSucursal}` : ``;
  let p6 = nroFactura ? `&nroFactura=${nroFactura}` : ``;
  return `${p1}${p2}${p3}${p4}${p5}${p6}`;

}

